// src/store/rootReducer.js
import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import adminSlice from "./slices/adminSlice";
import orderSlice from "./slices/orderSlice";
import categorySlice from "./slices/categorySlice";
import adminProductSlice from "./slices/adminProductSlice";
import userSlice from "./slices/userSlice";
import usageSlice from "./slices/usageSlice";
import companyDetailsSlice from "./slices/companyDetailsSlice";
import companySeoReducer from "./slices/companySeoSlice";
import notificationTemplates from "./slices/templateSlice";
import notificationCampaigns from "./slices/campaignSlice";
import notificationDevices from "./slices/deviceSlice";
import notificationAnalytics from "./slices/analyticsSlice";
import i18nReducer from "./slices/i18nSlice";
import planSlice from "./slices/jewelleryPlan/planSlice";
import paymentSlice from "./slices/jewelleryPlan/paymentSlice";
import planTemplateSlice from "./slices/jewelleryPlan/planTemplateSlice";
import jewellerySlice from "./slices/jewelleryPlan/jewellerySlice";
import quoteSlice from "./slices/jewelleryPlan/quoteSlice";
import cancellationSlice from "./slices/jewelleryPlan/cancellationSlice";
import redemptionSlice from "./slices/jewelleryPlan/redemptionSlice";
import offerSlice from "./slices/offerSlice";
import pricingSlice from "./slices/pricingSlice";
import rateSlice from "./slices/rateSlice";
import branchSlice from "./slices/branchSlice";
import permissionSlice from "./slices/permissionSlice";
import appSettingsSlice from "./slices/appSettingsSlice";
import adminCartReducer from "./slices/adminCartSlice";
import branchAppointmentConfigSlice from "./slices/branchAppointmentConfigSlice";
import appointmentSlice from "./slices/appointmentSlice";
import consultationSlice from "./slices/consultationSlice";
import branchInstallmentSlice from "./slices/branchInstallmentSlice";
import branchDisplaySlice from "./slices/branchDisplaySlice";

// Karigar Management imports
import karigarSlice from "./slices/karigar/karigarSlice";
import karigarJobSlice from "./slices/karigar/jobSlice";
import karigarPaymentSlice from "./slices/karigar/paymentSlice";
import orderKariarReducer from "./slices/karigar/orderKarigarSlice";

// Create the nested jewelleryPlan reducer
const jewelleryPlanReducer = combineReducers({
  plans: planSlice,
  payments: paymentSlice,
  planTemplates: planTemplateSlice,
  quotes: quoteSlice,
  jewellery: jewellerySlice,
  cancellation: cancellationSlice,
  redemption: redemptionSlice,
});

// Create the nested karigar reducer
// Access: state.karigar.karigar, state.karigar.job, state.karigar.payment
const karigarReducer = combineReducers({
  karigar: karigarSlice, // state.karigar.karigar
  job: karigarJobSlice, // state.karigar.job
  payment: karigarPaymentSlice, // state.karigar.payment
  order: orderKariarReducer, // state.karigar.orderKarigar
});

const rootReducer = combineReducers({
  auth: authReducer,
  user: userSlice,
  admin: adminSlice,
  adminPermission: permissionSlice,
  orders: orderSlice,
  cart: adminCartReducer,
  category: categorySlice,
  adminProduct: adminProductSlice,
  usage: usageSlice,
  companyDetails: companyDetailsSlice,
  companySeo: companySeoReducer,
  notificationTemplates,
  notificationCampaigns,
  notificationDevices,
  notificationAnalytics,
  i18n: i18nReducer,
  jewelleryPlan: jewelleryPlanReducer,
  offers: offerSlice,
  pricing: pricingSlice,
  rate: rateSlice,
  branch: branchSlice,
  branchAppointmentConfig: branchAppointmentConfigSlice,
  branchDisplay: branchDisplaySlice,
  appSettings: appSettingsSlice,
  appointment: appointmentSlice,
  consultation: consultationSlice,
  branchInstallment: branchInstallmentSlice,

  // Karigar Management (nested)
  karigar: karigarReducer,
});

export default rootReducer;
